import { fetchUtils } from 'react-admin';
import { httpClient } from 'providers/clients/httpClient';
import { stringifyOpts } from 'providers/clients/httpClient';
import { ExportResponse } from 'utility/types/dataProvider';
import { PayTransactionDetailPayload } from 'screens/community/transactions/types';

export type TransactionsProviderType = {
  exportTransactions: (payload: Record<string, any>) => Promise<ExportResponse>;
  getTransactionById: (id: string) => Promise<PayTransactionDetailPayload>;
};

export const transactionsProvider: TransactionsProviderType = {
  exportTransactions: async (payload: Record<string, any>) => {
    try {
      const path = `/pay/transactions/`;
      const normalizedPayload = {
        export: true,
        limit: payload?.limit ?? 1000,
        ...payload,
      };

      const response = await httpClient({
        url: `${path}?${fetchUtils.queryParameters(normalizedPayload, stringifyOpts)}`,
        method: 'GET',
      });

      const exportId =
        typeof response?.data?.data === 'string'
          ? response.data.data
          : typeof response?.data === 'string'
          ? response.data
          : null;

      return {
        status: response?.status ?? 500,
        exportId,
        isReady: false,
        data: exportId || '',
        resourceType: 'transactions',
      };
    } catch (error) {
      console.error('[exportTransactions] Error', error);
      throw error;
    }
  },

  getTransactionById: async (id: string) => {
    try {
      if (!id) {
        throw new Error('Transaction ID is required.');
      }

      const path = `/pay/transactions/${id}/`;

      const { data } = await httpClient({
        url: path,
        method: 'GET',
      });

      return data?.data as PayTransactionDetailPayload;
    } catch (error) {
      console.error('[getTransactionById] Error', error);
      throw error;
    }
  },
};
